const STORAGE_KEY_PREFIX = 'mcDoctorReviewDraft_v1';

const buildStorageKey = (sessionId) => {
  if (!sessionId) return null;
  return `${STORAGE_KEY_PREFIX}_${sessionId}`;
};

const safeParse = (raw) => {
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch (_error) {
    return null;
  }
};

export const loadDoctorReviewDraftSnapshot = (sessionId) => {
  const key = buildStorageKey(sessionId);
  if (!key || typeof window === 'undefined') return null;

  return safeParse(window.localStorage.getItem(key));
};

export const saveDoctorReviewDraftSnapshot = (sessionId, snapshot) => {
  const key = buildStorageKey(sessionId);
  if (!key || typeof window === 'undefined') return;

  window.localStorage.setItem(
    key,
    JSON.stringify({
      ...snapshot,
      savedAt: new Date().toISOString(),
    }),
  );
};

export const clearDoctorReviewDraftSnapshot = (sessionId) => {
  const key = buildStorageKey(sessionId);
  if (!key || typeof window === 'undefined') return;

  window.localStorage.removeItem(key);
};
